var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 41.7V8.85q0-1.149.864-2.011.862-.864 2.011-.864h21.85q1.148 0 2.012.864.863.862.863 2.011V41.7L24 35.8zm2.875-4.35L24 32.717l10.925 4.633V8.85h-21.85z"
  })));
};
export default SvgBookmark;